<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.isilive.ca/"> {{ $t("footer.brand") }} </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        {{ $t("footer.copyright") }}
        <a href="https://www.isilive.ca/" target="_blank">{{
          $t("footer.brand")
        }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "ContentFooter",
};
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 260px; /* Account for sidebar width */
  right: 0;
  background: rgb(var(--v-theme-surface-muted));
  border-top: 1px solid rgb(var(--v-theme-border-subtle));
  padding: 15px 30px;
  z-index: 100;
  font-size: 12px;
  color: rgb(var(--v-theme-text-muted));
}

.footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: none;
  padding: 0;
}

.footer nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.footer nav ul li {
  margin-right: 25px;
}

.footer nav ul li a {
  color: rgb(var(--v-theme-text-muted));
  text-decoration: none;
  font-size: 12px;
  transition: all 0.3s;
}

.footer nav ul li a:hover {
  color: rgb(var(--v-theme-on-surface));
}

.footer .copyright {
  font-size: 12px;
  color: rgb(var(--v-theme-text-muted));
}

.footer .copyright a {
  color: rgb(var(--v-theme-text-muted));
  text-decoration: none;
}

.footer .copyright a:hover {
  color: rgb(var(--v-theme-on-surface));
}

/* Responsive */
@media (max-width: 991px) {
  .footer {
    left: 0;
  }
}
</style>
